let tyreSystemIdSeed = 0;

export const getNextTyreSystemId = () => {
  tyreSystemIdSeed += 1;
  return `TYR-TMP-${Date.now()}-${tyreSystemIdSeed}`;
};

export const DEFAULT_TYRE_NOTES = "";

export const tyreBrandOptions = [
  "Michelin",
  "Bridgestone",
  "Dunlop",
  "Yokohama",
  "Continental",
  "Hankook",
  "Pirelli",
  "Apollo",
].map((item) => ({ label: item, value: item }));

export const tyreModelOptions = [
  "RoadForce X",
  "Duracore",
  "TrailPro",
  "RoadMax",
  "TruckLine",
  "PrimeAxle",
  "CargoPro",
  "Duramax",
].map((item) => ({ label: item, value: item }));

export const tyrePatternOptions = [
  { label: "Ribbed", value: "Ribbed" },
  { label: "Lug", value: "Lug" },
  { label: "Block", value: "Block" },
  { label: "Mixed", value: "Mixed" },
];

export const tyreTypeOptions = [
  { label: "Tubeless", value: "Tubeless" },
  { label: "Tube Type", value: "Tube Type" },
  { label: "Radial", value: "Radial" },
];

export const tyreSizeOptions = [
  { label: "295/80R22.5", value: "295/80R22.5" },
  { label: "315/80R22.5", value: "315/80R22.5" },
  { label: "12R22.5", value: "12R22.5" },
];

export const constructionTypeOptions = [
  { label: "Radial", value: "Radial" },
  { label: "Bias", value: "Bias" },
  { label: "Belted Bias", value: "Belted Bias" },
];

export const warehouseOptions = [
  "Karachi Warehouse",
  "Lahore Warehouse",
  "Islamabad Warehouse",
  "Rawalpindi Warehouse",
  "Faisalabad Warehouse",
  "Multan Warehouse",
  "Gujranwala Warehouse",
  "Peshawar Warehouse",
].map((item) => ({ label: item, value: item }));

export const tyreCurrentStatusOptions = [
  { label: "In Stock", value: "in_stock" },
  { label: "Installed", value: "installed" },
  { label: "Inactive", value: "inactive" },
];
